<!--  COMPLETE  -->
<div class="group-progress-bar border rounded d-flex w-100 mb-5">
  @if (complete > 0) {
    <div class="progress-complete d-flex w-100" [style.width]="complete + '%'">
      <div class="bg-success-light rounded-start d-flex justify-content-center w-100"
        [class.rounded-end]="complete == 100">
        <span class="progress-text small py-1 text-nowrap">
          {{complete | number: '1.0-0'}}%
          <i class="fas fa-check ps-1"></i>
        </span>
        <span class="progress-arrow"></span>
        <small class="progress-step">Complete</small>
      </div>
    </div>
  }

  <!--  IN PROGRESS  -->
  @if (inProgress > 0) {
    <div class="progress-in-progress d-flex w-100" [style.width]="inProgress + '%'">
      <div class="bg-unc-blue d-flex justify-content-center w-100"
        [class.rounded-start]="complete == 0"
        [class.rounded-end]="remaining == 0">
        <span class="progress-text small py-1 text-nowrap">
          {{inProgress | number: '1.0-0'}}%
          <i class="fas fa-spinner ps-1"></i>
        </span>
        <span class="progress-arrow"></span>
        <small class="progress-step">In Progress</small>
      </div>
    </div>
  }

  <!--  REMAINING -->
  @if (remaining > 0) {
    <div class="progress-remaining d-flex w-100" [style.width]="remaining + '%'">
      <div class="bg-light rounded-end d-flex justify-content-center w-100"
        [class.rounded-start]="remaining == 100">
        <span class="progress-text small py-1 text-nowrap">
          {{remaining | number: '1.0-0'}}%
          <i class="fas fa-rocket ps-1"></i>
        </span>
        <span class="progress-arrow"></span>
        <small class="progress-step">Still Required</small>
      </div>
    </div>
  }
</div>
